export function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
export function ownerWindow(node, fallback) {
  if (fallback === void 0) {
    fallback = window;
  }

  var doc = ownerDocument(node);
  return doc.defaultView || fallback;
}